import axios from '@/plugins/axios';
import apiUrls from '@/config/apiUrls';
import { useSubjectStore } from '@/store/subjectStore';
import { errorToast } from '@/utils/toastUtils';

const getSubject = async (): Promise<SubjectType> => {
  const subjectStore = useSubjectStore();
  if (!subjectStore.hasSelectedSubject) {
    await subjectStore.initializeStore();
  }
  return subjectStore.selectedSubject;
};

export const requestEditToken = async () => {
  const subjectId = (await getSubject()).identifier;
  try {
    const url = (apiUrls.requestEditToken as (subjectId: string) => string)(subjectId);
    const response = await axios.post(url);
    return response.data;
  } catch (error) {
    console.error(error);
    errorToast((error as any).response.data);
  }
};

export const getEditToken = async () => {
  const subjectId = (await getSubject()).identifier;
  try {
    const url = (apiUrls.getEditToken as (subjectId: string) => string)(subjectId);
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error(error);
    errorToast((error as any).response.data);
  }
};

export const freeEditToken = async () => {
  const subjectId = (await getSubject()).identifier;
  try {
    const url = (apiUrls.freeEditToken as (subjectId: string) => string)(subjectId);
    const response = await axios.delete(url);
    return response.data;
  } catch (error) {
    console.error(error);
    errorToast((error as any).response.data);
  }
};

export const prolongEditToken = async () => {
  const subjectId = (await getSubject()).identifier;
  try {
    const url = (apiUrls.prolongEditToken as (subjectId: string) => string)(subjectId);
    const response = await axios.put(url, {});
    return response.data;
  } catch (error) {
    console.error(error);
    errorToast((error as any).response.data);
  }
};
